// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "." + {"443":"84e58378","672":"70398a45","985":"0d7a1f7d"}[chunkId] + ".js";
};